import { render, staticRenderFns } from "./memberPurchase.vue?vue&type=template&id=0f326ce2&scoped=true"
import script from "./memberPurchase.vue?vue&type=script&lang=js"
export * from "./memberPurchase.vue?vue&type=script&lang=js"
import style0 from "./memberPurchase.vue?vue&type=style&index=0&id=0f326ce2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f326ce2",
  null
  
)

export default component.exports